import { render } from "./AcceptModal.vue?vue&type=template&id=1d5fa37c"
import script from "./AcceptModal.vue?vue&type=script&lang=js"
export * from "./AcceptModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__